/**
 * AeroSpray scroll reveal — the CSS equivalent of Framer Motion's `whileInView`.
 *
 * Gating is opt-in: the hidden state only applies once this script adds
 * `aero-motion` to <html>. If the script never runs, nothing is ever hidden.
 * (Horizon sets a `no-js` class on <html> but never removes it, so it cannot
 * be used to detect JS.)
 */
(() => {
  const SELECTOR = '.aero-reveal';
  const root = document.documentElement;

  const reveal = (el) => el.classList.add('is-visible');

  if (!('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -60px 0px', threshold: 0 }
  );

  const collect = (target) => {
    const found = [];
    if (target instanceof Element && target.matches(SELECTOR)) found.push(target);
    target.querySelectorAll?.(SELECTOR).forEach((el) => found.push(el));
    return found;
  };

  const register = (target, skipInViewport) => {
    collect(target).forEach((el) => {
      // Anything already on screen is revealed synchronously, before the hidden
      // state is switched on, so the first paint never flashes.
      if (skipInViewport && el.getBoundingClientRect().top < window.innerHeight) {
        reveal(el);
        return;
      }
      observer.observe(el);
    });
  };

  register(document, true);
  root.classList.add('aero-motion');

  // Sections re-render on every theme-editor change.
  document.addEventListener('shopify:section:load', (event) => register(event.target, false));
  document.addEventListener('shopify:block:select', (event) => register(event.target, false));
})();
